import React from "react";
import { COMMENT01, COMMENT02 } from "../../lib/assets";

export const BlogComments = () => {
  return (
    <div className="comments-wrap">
      <h3 className="comments-wrap-title">02 Comments</h3>
      <div className="latest-comments">
        <ul className="list-wrap">
          <li>
            <div className="comments-box">
            {/*  <div className="comments-avatar">
                <img src={COMMENT01} alt="img" />
              </div>*/}
              <div className="comments-text">
                <div className="avatar-name">
                  <h6 className="name">Sowmya</h6>
                  <span className="date">December 27, 2023</span>
                </div>
                <p>
                I just read your latest blog on insurance and I must say, it's incredibly insightful! Your ability to break down complex concepts into easy-to-understand language is truly appreciated. I'll definitely be sharing this with friends and family who could benefit from your expertise.
                </p>
                <a href="#" className="reply-btn">
                  Reply
                </a>
              </div>
            </div>
            <ul className="children">
              <li>
                <div className="comments-box">
                {/*  <div className="comments-avatar">
                    <img src={COMMENT02} alt="img" />
                  </div>*/}
                  <div className="comments-text">
                    <div className="avatar-name">
                      <h6 className="name">Mohan</h6>
                      <span className="date">December 28, 2023</span>
                    </div>
                    <p>
                      Thank you for sharing such valuable information about insurance! Your blog has helped me understand the importance of having the right coverage and I feel more confident in making informed decisions about my insurance needs.
                    </p>
                    <a href="#" className="reply-btn">
                      Reply
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};
